import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SuiTextInput } from '@splashthat/sui';
import get from 'lodash/get';

import { getFormNode } from 'common/entities/formNode/selectors';
import { setInitialValue } from '../../../actions';
import disableWhenLocked from './disableWhenLocked';

const DEFAULT_VALUE_LABEL = 'Default value';
const BASE_COMPONENT_NAME = 'DefaultValueControl';

const DefaultValueControl = ({ initialValue, onChange, disabled }) => (
    <SuiTextInput
        fullWidth
        label={DEFAULT_VALUE_LABEL}
        defaultValue={initialValue}
        onChange={(event, value) => onChange(value)}
        disabled={disabled}
        data-qa={`${BASE_COMPONENT_NAME}__input`}
    />
);

DefaultValueControl.propTypes = {
    initialValue: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    /** disabled is passed when form node editing is locked */
    disabled: PropTypes.bool.isRequired,
};

// -------------------
// Connected component

const mapStateToProps = (state, props) => {
    const formNode = getFormNode(state, props.formNodeId);
    return {
        initialValue: props.formNodeId ? get(formNode, 'config.initialValue', '') : '',
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onChange: (initialValue) => dispatch(setInitialValue(ownProps.formNodeId, initialValue)),
});

const ConnectedDefaultValueControl = connect(
    mapStateToProps,
    mapDispatchToProps,
)(disableWhenLocked(DefaultValueControl));

ConnectedDefaultValueControl.propTypes = {
    formNodeId: PropTypes.string,
};
ConnectedDefaultValueControl.defaultProps = {
    formNodeId: undefined,
};

export default ConnectedDefaultValueControl;
